import { Component, Input } from '@angular/core';
import { AFormat } from '@df/interfaces';

@Component({
    selector: 'app-exercise-preview-sequence',
    templateUrl: './exercise-preview-sequence.component.html',
    styleUrls: ['../../../../_pipes/exercise-format.pipe.scss', './exercise-preview-sequence.component.scss']
})
export class ExercisePreviewSequenceComponent {
    @Input() exercise: any;
    @Input() card_format: string;
    @Input() index: number;
    @Input() mainCardView = false;

    constructor() {}

    getWidth(card_format) {
        if (card_format === AFormat.A5_FORMAT) {
            return '200%';
        } else if (card_format === AFormat.A3_FORMAT) {
            return '150%';
        }
        return '100%';
    }

    getMargin(card_format) {
        if (this.mainCardView) {
            if (card_format === AFormat.A7_FORMAT) {
                return '45px';
            }
            if (card_format === AFormat.A6_FORMAT) {
                return '30px';
            }
            if (card_format === AFormat.A3_FORMAT) {
                return '35px';
            }
            return '25px';
        }
        if (card_format === AFormat.A5_FORMAT || card_format === AFormat.A3_FORMAT) {
            return '25px';
        }
        if (card_format === AFormat.A7_FORMAT) {
            return '40px';
        }
        return '20px';
    }
}
